import React, { useState } from 'react';
import useStyle from './switch.style';

export interface SwitchProps {
  onClick: (value: boolean) => void;
  defaultValue?: boolean;
}

export const Switch = ({ onClick, defaultValue = false }: SwitchProps) => {
  const [switchValue, setSwitchValue] = useState(defaultValue);
  const classes = useStyle();

  const onChange = (value: boolean) => {
    setSwitchValue(value);
    onClick(value);
  };

  return (
    <div onClick={() => onChange(!switchValue)} className={classes.root}>
      <svg
        width="44"
        height="24"
        viewBox="0 0 44 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className={classes.rect}
          y="0.5"
          width="44"
          height="23"
          rx="11.5"
        />
        <circle
          className={`${classes.circle} ${
            switchValue ? classes.circleYes : classes.circleNo
          }`}
          cy="12"
          r="8.5"
        />
      </svg>

      <span className={switchValue ? classes.yes : classes.no}>
        {switchValue ? 'oui' : 'non'}
      </span>
    </div>
  );
};
